import { L } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ScheduledProgramInstanceOption } from '../../../../../../Types';
import { utcDateToLocalDate } from '../../../../../Functions';

export interface Props {
  scheduledOption: ScheduledProgramInstanceOption;
}

const StartDate: React.FC<Props> = ({ scheduledOption }) => (
  <div className="flex flex-col mr-2 border-r-1 border-r-slate-50 text-sm mb-4">
    <div>
      <L localizeable={utcDateToLocalDate(scheduledOption.startOn)} format={'long-weekday'} />
    </div>
    <div>
      <L
        localizeable={utcDateToLocalDate(scheduledOption.startOn)}
        format={'long-month-day-year'}
      />
    </div>
  </div>
);

export default observer(StartDate);
